import React from 'react';
import styles from 'Custom/HeroQuestion/index.module.scss';
import ItemBreakpoint from 'Custom/ItemBreakpoint/index';
import HeroFull from 'Nori/Hero/HeroFull';
import Button from 'Nori/Button';
import SplitContent from 'Custom/Split/SplitContent';
import QUESTIONS_IMAGE from 'Images/misc/icon-question-desktop.webp';
import QUESTIONS_IMAGE_MOBILE from 'Images/misc/icon-question-mobile.webp';
import RichText from 'Custom/RichText';
import AjustableImage from 'Custom/AjustableImage';
import BLUE_BG_IMAGE from 'Images/misc/dark-blue-bg.png';
import BLUE_BG_IMAGE_MOBILE from 'Images/misc/dark-blue-bg-mobile.png';

const HeroQuestion = ({ className = '', moduleNo = '01' }) => (
  <div data-qa-tag="question-wrapper" className={styles.heroQuesWrapper}>
    <ItemBreakpoint breakpoint="lg">
      <HeroFull image={BLUE_BG_IMAGE} data-qa-tag="question-hero-wrapper">
        <SplitContent
          data-qa-tag="question-split-wrapper"
          alignContent={'alignCenter'}
          splitAutoWidth={'splitAutoWidth'}
          data-design-visible="visible_vd"
          data-design-type="module"
          data-design-nori_id="Inline Content"
          data-design-module_name="side effects of NEXPLANON"
          data-design-module_no={moduleNo}
        >
          <AjustableImage
            data-qa-tag="question-image"
            size={'full'}
            image={{ src: QUESTIONS_IMAGE, style: { width: 192, height: 192 }, alt: '' }}
          />
          <>
            <RichText
              className="quesContent"
              data-qa-tag="question-content-wrapper"
            >
              <div className="mb questionTitle" data-qa-tag="question-title">
                Still have questions?
              </div>
              <div className="intro" data-qa-tag="question-description">
                <p data-qa-tag="question-content-a">Check out our FAQs.
                </p>
                <p>
                  These may be helpful to you.
                </p>
              </div>
            </RichText>
            <Button
              data-qa-tag="question-button"
              type="secondary4"
              href="/questions/"
              data-design-type="clickAction"
              data-design-category="button_vd"
              data-design-action="Button"
              data-design-label="Explore our FAQs"
              data-design-nori_id="Inline Content"
              data-design-module_name="still have questions?"
              data-design-module_no={moduleNo}
            >
              Explore Our FAQs
            </Button>
          </>
        </SplitContent>
      </HeroFull>
      <HeroFull
        image={BLUE_BG_IMAGE_MOBILE}
        data-qa-tag="question-hero-wrapper"
      >
        <SplitContent
          data-qa-tag="question-split-wrapper"
          alignContent={'alignCenter'}
          splitAutoWidth={'splitAutoWidth'}
          data-design-visible="visible_vd"
          data-design-type="module"
          data-design-nori_id="Inline Content"
          data-design-module_name="side effects of NEXPLANON"
          data-design-module_no="05"
        >
          <AjustableImage
            data-qa-tag="question-image"
            size={'full'}
            image={{
              src: QUESTIONS_IMAGE_MOBILE,
              style: { width: 146, height: 146 },
              alt: ''
            }}
          />
          <>
            <RichText
              className="quesContent"
              data-qa-tag="question-content-wrapper"
            >
              <h2 data-qa-tag="question-title" className="mb">
                Still have questions?
              </h2>
              <p data-qa-tag="question-description" className="intro">
                Check out our FAQs.</p>
              <p data-qa-tag="question-description" className="intro">
                These may be helpful to you.
              </p>
            </RichText>
            <Button
              data-qa-tag="question-button"
              type="secondary4"
              href="/questions/"
              data-design-type="clickAction"
              data-design-category="button_vd"
              data-design-action="Button"
              data-design-label="Explore our FAQs"
              data-design-nori_id="Inline Content"
              data-design-module_name="still have questions?"
              data-design-module_no="07"
            >
              Explore Our FAQs
            </Button>
          </>
        </SplitContent>
      </HeroFull>
    </ItemBreakpoint>
  </div >
);

export default HeroQuestion;
